module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="team-filed-pitch">\n	<a href="https://hisense.com.au/" class="team-field-ad left" target="_blank" rel="noopener noreferrer"></a>\n	';
 _.size(positions_by_id) && _.each(_.omit(lineup, 'bench'), function(field_row, pos_id) {  
__p+='\n		<div class="team-filed-pitch-row">\n			<span class="field-position-name field-position-name-'+
((__t=( pos_id ))==null?'':_.escape(__t))+
'">\n				'+
((__t=( _.result(positions_by_id, pos_id, {}).short_name ))==null?'':_.escape(__t))+
'\n			</span>\n			';
 _.each(field_row, function(player){ 
__p+='\n				';
 if(player.id){ 
__p+='\n				<div\n					class="player-cell '+
((__t=( player.substitute_class_name ))==null?'':_.escape(__t))+
' '+
((__t=( player.leader_class_name ))==null?'':_.escape(__t))+
' '+
((__t=( player.is_dnp && player.is_locked ? 'is-dnp' : '' ))==null?'':_.escape(__t))+
'"\n					data-player-id="'+
((__t=( player.id ))==null?'':_.escape(__t))+
'"\n					data-position-id="'+
((__t=( pos_id ))==null?'':_.escape(__t))+
'">\n\n					';
 if (selected_stat === 'stats.proj_score') { 
__p+='\n						<span class="round-scores projected">'+
((__t=( _.result(player, selected_stat, 0) ))==null?'':_.escape(__t))+
'</span>\n					';
 } else { 
__p+='\n						<span class="round-scores '+
((__t=( player.is_playing_now && (player.stats.points_last_round || player.stats.points_last_round === 0) ? 'is-scoring-now' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( player.is_dnp ? 'dnp' : '' ))==null?'':_.escape(__t))+
'">\n							'+
((__t=( player.stats.points_last_round ))==null?'':_.escape(__t))+
'\n						</span>\n					';
 } 
__p+='\n\n					';
 if(!player.is_locked){ 
__p+='\n						<a class="js-more-tools more-tools">\n							<i class="icon ion-android-more-horizontal"></i>\n							<i class="icon ion-android-close"></i>\n						</a>\n						<a class="js-cancel-substitute cancel-substitute">\n							<i class="icon ion-android-close"></i>\n						</a>\n\n						<div class="player-cell-btns">\n							';
 if(player.can_be_captain ){ 
__p+='\n								<a class="icon icon-captain js-set-captain">C</a>\n							';
 } 
__p+='\n\n							';
 if(player.can_be_vice_captain){ 
__p+='\n								<a class="icon icon-vice-captain js-set-vice-captain">V</a>\n							';
 } 
__p+='\n\n							<a class="icon icon-substitute js-substitute">S</a>\n\n							';
 if(player.is_removable){ 
__p+='\n								<a class="icon icon-remove js-remove"></a>\n							';
 } else if(player.can_be_trade_out){ 
__p+='\n								<a class="icon icon-trade js-trade">T</a>\n							';
 } 
__p+='\n						</div>\n					';
 } else { 
__p+='\n						<div class="more-tools">\n							<i class="ion-ios-locked"></i>\n						</div>\n					';
 } 
__p+='\n\n					<div class="figure">\n						';
 if(player.leader_class_name){ 
__p+='\n							<i class="icon player-status player-lead-status '+
((__t=( player.leader_class_name ))==null?'':_.escape(__t))+
'"></i>\n						';
 } 
__p+='\n						<figure>\n							<picture>\n								<source	srcset="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100, format:'webp' }) ))==null?'':_.escape(__t))+
'" type="image/webp" />\n								<img src="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100 }) ))==null?'':_.escape(__t))+
'" />\n							</picture>\n						</figure>\n					</div>\n					<div class="player-info">\n						<div class="player-name">\n							<i class="player-status '+
((__t=( player.status ))==null?'':_.escape(__t))+
'"></i>\n							<span>'+
((__t=( player.first_name[0] ))==null?'':_.escape(__t))+
'. '+
((__t=( player.last_name ))==null?'':_.escape(__t))+
'</span>\n						</div>\n						';
 if(is_coach_enabled){ 
__p+='\n							<div class="player-stats-coach">\n								';
 if(has_assistant_coach) { 
__p+='\n									<div class="proj-score">\n										PROJ.<b>'+
((__t=( player.stats.proj_score ))==null?'':_.escape(__t))+
'</b>\n										&nbsp;\n										BE.<b>'+
((__t=( player.stats.break_even ))==null?'':_.escape(__t))+
'</b>\n									</div>\n									';
 if(player.stats.bye_round_id){ 
__p+='\n										<div class="bye-rd">BYE RD. <span>'+
((__t=( player.stats.bye_round_id ))==null?'':_.escape(__t))+
'</span></div>\n									';
 } 
__p+='\n								';
 } else { 
__p+='\n									<!-- User has no assistant coach but trigger to show coach data -->\n									<img class="coach-locked js-coach-locked" src="/assets/images/icon-coach-locked.png" alt="">\n								';
 } 
__p+='\n							</div>\n						';
 } else { 
__p+='\n							<div class="player-stats">\n								<span class="player-positions">\n									'+
((__t=( player.position_names.join(', ') ))==null?'':_.escape(__t))+
'\n								</span>\n								<span class="'+
((__t=( selected_stat === 'stats.proj_score' ? 'hidden' : '' ))==null?'':_.escape(__t))+
'"> | </span>\n								<span class="player-cost '+
((__t=( _.includes(['stats.break_even', 'stats.proj_score'], selected_stat) ? 'stats-coach' : '' ))==null?'':_.escape(__t))+
'">\n									'+
((__t=( selected_stat === 'cost' ? _.currencyFormat(player.cost, '').toUpperCase() : '' ))==null?'':_.escape(__t))+
'\n									'+
((__t=( selected_stat === 'stats.avg_points' ? ('AVG: ' + _.result(player, selected_stat, 0).toFixed(1)) : '' ))==null?'':_.escape(__t))+
'\n									'+
((__t=( selected_stat === 'stats.total_points' ? ('TOT: ' + _.result(player, selected_stat)) : '' ))==null?'':_.escape(__t))+
'\n									'+
((__t=( selected_stat === 'stats.owned_by' ? ('TS%: ' + _.result(player, selected_stat, 0).toFixed(1)) + '%' : '' ))==null?'':_.escape(__t))+
'\n									'+
((__t=( selected_stat === 'stats.cost_divided_by_points' ? ('$/PTS: ' + _.result(player, selected_stat)) : '' ))==null?'':_.escape(__t))+
'\n									'+
((__t=( selected_stat === 'stats.last_3_avg' ? ('L3 AVG: ' + _.result(player, selected_stat, 0).toFixed(1)) : '' ))==null?'':_.escape(__t))+
'\n									'+
((__t=( selected_stat === 'stats.break_even' ? ('BE: ' + _.result(player, selected_stat, 0)) : '' ))==null?'':_.escape(__t))+
'\n									<!--'+
((__t=( selected_stat === 'stats.proj_score' ? ('PROJ: ' + _.result(player, selected_stat, 0)) : '' ))==null?'':_.escape(__t))+
'-->\n								</span>\n							</div>\n						';
 } 
__p+='\n					</div>\n				</div>\n				';
 } else { 
__p+='\n					<div class="player-cell-empty" data-position-id="'+
((__t=( pos_id ))==null?'':_.escape(__t))+
'">\n						<div>\n							<i class="icon ion-plus"></i>\n							<span class="empty-player-cell-position">\n								'+
((__t=( _.result(positions_by_id, pos_id, {}).short_name ))==null?'':_.escape(__t))+
'\n							</span>\n						</div>\n					</div>\n				';
 } 
__p+='\n			';
 }) 
__p+='\n		</div>\n	';
 })  
__p+='\n	<a href="https://hisense.com.au/" class="team-field-ad right" target="_blank" rel="noopener noreferrer"></a>\n</div>';
}
return __p;
};
